export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];